export enum LoanStatus {
  REQUESTED_WARRANTY = 1,
  UNDER_ANALYSIS = 2,
  PENDING_CONTRACT_SIGN = 3,
  APPROVED = 4,
  REPROVED = 5,
  ERROR_TO_APPROVE = 6,
  CONTRACT_SIGN_DEADLINE = 7,
  CANCELED = 8,
  ERROR_TO_CONFIRM_CCB = 9,
  SIMULATION_EXECUTED = 10,
  REQUESTED_BY_USER = 11,
}

export enum Gender {
  MALE = 1,
  FEMALE = 2,
  OTHER = 3,
  NOT_SPECIFIED = 4,
}

export enum LoanSimulationTab {
  ADVANTAGES = 1,
  FINANCIAL_DATA = 2,
  CONTRACT = 3,
  CONFIRMATION = 4,
  WARRANTY = 5,
}
